"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizableChart = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
function ResizableChart(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [size, setSize] = (0, react_1.useState)({ width: 0, height: 0 });
    const panelRef = (0, react_1.createRef)();
    (0, react_1.useEffect)(() => {
        const { current } = panelRef;
        if (!current)
            return;
        const resizeObserver = new ResizeObserver(([{ contentRect }]) => {
            const { width, height } = contentRect;
            (width !== size.width || height !== size.height) &&
                setSize({ width, height });
        });
        resizeObserver.observe(current);
        return () => {
            resizeObserver.unobserve(current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [panelRef]);
    const charts = react_1.Children.toArray(children);
    const chart = charts && charts[0] && (0, react_1.cloneElement)(charts[0], size);
    return (react_1.default.createElement(styled_1.StyledResizableContainer, Object.assign({ ref: panelRef }, props), chart || children));
}
exports.ResizableChart = ResizableChart;
//# sourceMappingURL=main.js.map